module.exports = "<div ng-if=\"Ctrl.opt.view == 'horizontal'\" ng-include=\"'horizontal-template.html'\"></div>\n<div ng-if=\"Ctrl.opt.view == 'vertical'\" ng-include=\"'vertical-template.html'\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/filters-report/templates/main-template.html
// module id = 285
// module chunks = 0